import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/css/styles.css";

import "./assets/css/plugin.css";
import "./assets/css/bootstrap.min.css";
import "./assets/icons/font-awesome.min.css"
import "./assets/css/default.css";


// import "./assets/css/responsive.css";
import { Link } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
